import { render, staticRenderFns } from "./bulma_fieldset2props.vue?vue&type=template&id=d9bf2fda&scoped=true"
import script from "./bulma_fieldset2props.vue?vue&type=script&lang=js"
export * from "./bulma_fieldset2props.vue?vue&type=script&lang=js"
import style0 from "./bulma_fieldset2props.vue?vue&type=style&index=0&id=d9bf2fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bf2fda",
  null
  
)

export default component.exports